// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"131":"43bca69a","551":"8a767777","842":"24ce694e"}[chunkId] + ".chunk.js";
};